import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { Map as ImmutableMap } from 'immutable';
//
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { authSelectors } from 'app-components/flux/auth';
import { rootUiActions, rootUiSelectors, rootUiTypes } from 'app-components/flux/root-ui';
import { getLogger } from 'app-components/utils/core';

import { accountDiscoveryTypes } from 'app-components/flux/account-discovery';
import AccountDiscoveryDialog from 'components/Dialogs/AccountDiscovery';

import AlertDialog from 'components/Dialogs/AlertDialog';
import { DIALOG_TYPE as DIALOG_TYPE_ALERT } from 'components/Dialogs/AlertDialog/types';

import ConfirmationDialog, { DIALOG_TYPE as DIALOG_TYPE_CONFIRMATION } from 'components/Dialogs/ConfirmationDialog';

import FormDialog from 'components/Dialogs/FormDialog';
import { DIALOG_TYPE as DIALOG_TYPE_FORM } from 'components/Dialogs/FormDialog/types';

import NotificationDialog from 'components/Dialogs/NotificationDialog';
import { DIALOG_TYPE as DIALOG_TYPE_NOTIFICATION } from 'components/Dialogs/NotificationDialog/types';

import RefreshTimeoutDialog, {
  DIALOG_TYPE as DIALOG_TYPE_REFRESH_TIMEOUT,
} from 'components/Dialogs/RefreshTimeoutDialog';

import { DIALOG_TYPE_NPS_SURVEY } from 'app-components/flux/nps';
import NPSSurveyDialog from 'components/Dialogs/NPSSurveyDialog';

import DeleteReminderDialog from 'components/Dialogs/DeleteReminderDialog';
import { DIALOG_TYPE as DIALOG_TYPE_DELETE_REMINDER } from 'components/Dialogs/DeleteReminderDialog/actions';

import DeleteTransactionRuleDialog from 'components/Dialogs/DeleteTransactionRule';
import { DIALOG_TYPE as DIALOG_TYPE_DELETE_TRANSACTION_RULE } from 'components/Dialogs/DeleteTransactionRule/actions';

import CancelTransactionRuleDialog from 'components/Dialogs/CancelTransactionRule';
import { DIALOG_TYPE as DIALOG_TYPE_CANCEL_TRANSACTION_RULE } from 'components/Dialogs/CancelTransactionRule/actions';

import MatchTxnDialog from 'components/Dialogs/MatchTxnDialog';
import { DIALOG_TYPE as DIALOG_TYPE_MATCH_TXN } from 'components/Dialogs/MatchTxnDialog/actions';

import AddPlannedSpending from 'components/Dialogs/AddPlannedSpending';
import { DIALOG_TYPE as DIALOG_TYPE_PLANNED_SPENDING } from 'components/Dialogs/AddPlannedSpending/actions';

import DeletePlannedSpending from 'components/Dialogs/DeletePlannedSpending';
import { DIALOG_TYPE as DIALOG_TYPE_PLANNED_SPENDING_DELETE } from 'components/Dialogs/DeletePlannedSpending/actions';

import EditPlannedSpending from 'components/Dialogs/EditPlannedSpending';
import { DIALOG_TYPE as DIALOG_TYPE_PLANNED_SPENDING_EDIT } from 'components/Dialogs/EditPlannedSpending/actions';

import EditPlannedSpendingSeries from 'components/Dialogs/EditPlannedSpendingSeries';
import { DIALOG_TYPE as EDIT_PLANNED_SPENDING_SERIES_DIALOG } from 'components/Dialogs/EditPlannedSpendingSeries/actions';

import EditReminderDialog from 'components/Dialogs/EditReminderDialog';
import { DIALOG_TYPE as DIALOG_TYPE_EDIT_REMINDER } from 'components/Dialogs/EditReminderDialog/actions';

import { DIALOG_TYPE as DIALOG_TYPE_FIRST_USE } from 'components/Dialogs/FirstTimeUse/spendingPlanFirstUse/actions';
import SpendingPlanFirstUse from 'components/Dialogs/FirstTimeUse/spendingPlanFirstUse/spendingPlanFirstUse';

import { DIALOG_TYPE as DIALOG_TYPE_FIRST_USE_V2 } from 'components/Dialogs/FirstTimeUse/spendingPlanFirstUseV2/actions';
import SpendingPlanFirstUseV2 from 'components/Dialogs/FirstTimeUse/spendingPlanFirstUseV2/spendingPlanFirstUseV2';

import WatchlistFirstUse from 'components/Dialogs/FirstTimeUse/watchlistFirstUse';
import { DIALOG_TYPE as DIALOG_TYPE_SWL_FIRST_USE } from 'components/Dialogs/FirstTimeUse/watchlistFirstUse/actions';

import WatchlistModal from 'components/Dialogs/WatchlistModal';
import { DIALOG_TYPE as DIALOG_TYPE_WATCHLIST } from 'components/Dialogs/WatchlistModal/actions';

import CreditReportCancelRegistrationDialog from 'components/Dialogs/CreditScore/CancelRegistrationDialog';
import CreditReportUpdateDialog from 'components/Dialogs/CreditScore/CreditReportUpdateDialog';
import CreditScoreRegistrationDialog from 'components/Dialogs/CreditScore/CreditScoreRegistrationDialog';
import CreditScoreVerificationEventsDialog from 'components/Dialogs/CreditScore/CreditScoreVerificationEventsDialog';
import CreditScoreVerificationSentDialog from 'components/Dialogs/CreditScore/CreditScoreVerificationSentDialog';
import CreditScoreVerificationLoadingDialog from 'components/Dialogs/CreditScore/LoadingDialog';
import {
  DIALOG_TYPE_CANCEL_REGISTRATION,
  DIALOG_TYPE_CREDIT_REPORT_UPDATE,
  DIALOG_TYPE_CREDIT_SCORE_LOADING,
  DIALOG_TYPE_CREDIT_SCORE_REGISTER,
  DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_EVENTS,
  DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_SENT,
} from 'components/Dialogs/CreditScore/actions';

import ViewSeriesDialog from 'components/Dialogs/ViewSeriesDialog';
import { DIALOG_TYPE as DIALOG_TYPE_VIEW_SERIES } from 'components/Dialogs/ViewSeriesDialog/actions';

import BillPresentmentDialog from 'components/Dialogs/BillPresentment';
import { DIALOG_TYPE as DIALOG_TYPE_BILL_PRESENTMENT } from 'components/Dialogs/BillPresentment/actions';

import BillScoutDialog from 'components/Dialogs/BillScout';
import { DIALOG_TYPE as DIALOG_TYPE_BILL_SCOUT } from 'components/Dialogs/BillScout/actions';

import ScheduledTransactionAddDialog from 'components/Dialogs/ScheduledTransactionAddDialog';
import { DIALOG_TYPE as DIALOG_TYPE_SCHEDULED_TRANSACTION_ADD } from 'components/Dialogs/ScheduledTransactionAddDialog/actions';

import { DIALOG_TYPE as DIALOG_TYPE_TRANSACTION_DETAILS } from 'components/Transactions/DetailsDialog/actions';

import AssetDialog from 'components/Dialogs/AssetDialog';
import { DIALOG_TYPE_ASSET } from 'components/Dialogs/AssetDialog/actions';

import ManageUpdatesDialog from 'components/Dialogs/ManageUpdatesDialog';
import { MANAGE_UPDATES_DIALOG } from 'components/Dialogs/ManageUpdatesDialog/dispatcher';

import AddGoal from 'components/Dialogs/Goals/AddGoal';
import ContributeToGoal from 'components/Dialogs/Goals/ContributeToGoal';
import WithdrawFromGoal from 'components/Dialogs/Goals/WithdrawFromGoal';
import {
  ADD_GOAL_DIALOG_TYPE as DIALOG_TYPE_ADD_GOAL,
  CONTRIBUTE_TO_GOAL_DIALOG_TYPE as DIALOG_TYPE_CONTRIBUTE_TO_GOAL,
  WITHDRAW_FROM_GOAL_DIALOG_TYPE as DIALOG_TYPE_WITHDRAW_FROM_GOAL,
} from 'components/Dialogs/Goals/actions';

import AccountTransfersDialog from 'components/Dialogs/A2A/AccountTransfersDialog';
import MicrodepositConfirmationDialog from 'components/Dialogs/A2A/MicrodepositConfirmationDialog';
import OnboardAccountsForTransfersDialog from 'components/Dialogs/A2A/OnboardAccountsForTransfers';
import TransferActivityDetails from 'components/Dialogs/A2A/TransferActivityDetails';
import {
  DIALOG_TYPE_ACCOUNTS_TRANSFERS,
  DIALOG_TYPE_MICRODEPOSIT_CONFIRMATION_FOR_TRANSFERS,
  DIALOG_TYPE_ONBOARD_ACCOUNTS_FOR_TRANSFERS,
  DIALOG_TYPE_TRANSFER_ACTIVITY_DETAILS,
} from 'components/Dialogs/A2A/actions';

import AccountEditDialog, { DIALOG_TYPE_ACCOUNT_EDIT } from 'components/Dialogs/AccountEditDialog';
import AddRuleDialog, { DIALOG_TYPE_ADD_RULE } from 'components/Dialogs/AddRuleDialog';
import EmailVerificationDialog, { DIALOG_TYPE_EMAIL_VERIFICATION_DIALOG } from 'components/Dialogs/EmailVerification';
import EmptyDialog, { DIALOG_TYPE_EMPTY_DIALOG } from 'components/Dialogs/EmptyDialog';
import IdentityVerificationDialog, {
  DIALOG_TYPE_IDENTITY_VERIFICATION_DIALOG,
} from 'components/Dialogs/IdentityVerification';
import InvestmentTransactionEditDialog, {
  DIALOG_TYPE_INVESTMENT_TRANSACTIONS_EDIT,
} from 'components/Dialogs/InvestmentTransactionEditDialog';
import MemorizedRuleEditDialog, { DIALOG_TYPE_MEMORIZED_RULE_EDIT } from 'components/Dialogs/MemorizedRuleEditDialog';
import PhoneVerificationDialog, { DIALOG_TYPE_PHONE_VERIFICATION_DIALOG } from 'components/Dialogs/PhoneVerification';
import RefundEditDialog, { DIALOG_TYPE_REFUND_EDIT } from 'components/Dialogs/RefundEditDialog';
import RefundMatchDialog, { DIALOG_TYPE_REFUND_MATCH } from 'components/Dialogs/RefundMatchDialog';
import RenameRuleEditDialog, { DIALOG_TYPE_RENAME_RULE_EDIT } from 'components/Dialogs/RenameRuleEditDialog';
import ReportErrorDialog, { DIALOG_TYPE_REPORT_ERROR } from 'components/Dialogs/ReportErrorDialog';
import SecurityEditDialog, { DIALOG_TYPE_SECURITY_EDIT } from 'components/Dialogs/SecurityEditDialog';
import TxnSettings from 'components/Dialogs/TransactionsSettingsDialog';
import { DIALOG_TYPE_TXN_SETTINGS } from 'components/Dialogs/TransactionsSettingsDialog/actions';
import { INVOICE_PAYMENT_ROOTUI_TYPE } from 'components/InvoicePayment/actions';

import { ImportModalComponent, MODAL_COMPONENTS, RegisterModalComponent } from './modalRegistry';

const log = getLogger('components/RootModal/index');

// shared
RegisterModalComponent(DIALOG_TYPE_TXN_SETTINGS, TxnSettings);
RegisterModalComponent(accountDiscoveryTypes.DIALOG_TYPE_ACCOUNTS_DISCOVERY, AccountDiscoveryDialog);
RegisterModalComponent(DIALOG_TYPE_ALERT, AlertDialog);
RegisterModalComponent(DIALOG_TYPE_ASSET, AssetDialog);
RegisterModalComponent(DIALOG_TYPE_CONFIRMATION, ConfirmationDialog);
RegisterModalComponent(DIALOG_TYPE_FORM, FormDialog);
RegisterModalComponent(DIALOG_TYPE_NOTIFICATION, NotificationDialog);
RegisterModalComponent(DIALOG_TYPE_REFRESH_TIMEOUT, RefreshTimeoutDialog);
RegisterModalComponent(DIALOG_TYPE_NPS_SURVEY, NPSSurveyDialog);
RegisterModalComponent(DIALOG_TYPE_ADD_GOAL, AddGoal);
RegisterModalComponent(DIALOG_TYPE_WITHDRAW_FROM_GOAL, WithdrawFromGoal);
RegisterModalComponent(DIALOG_TYPE_CONTRIBUTE_TO_GOAL, ContributeToGoal);
RegisterModalComponent(DIALOG_TYPE_FIRST_USE_V2, SpendingPlanFirstUseV2);
RegisterModalComponent(DIALOG_TYPE_FIRST_USE, SpendingPlanFirstUse);
RegisterModalComponent(DIALOG_TYPE_SWL_FIRST_USE, WatchlistFirstUse);
RegisterModalComponent(DIALOG_TYPE_WATCHLIST, WatchlistModal);
RegisterModalComponent(DIALOG_TYPE_ONBOARD_ACCOUNTS_FOR_TRANSFERS, OnboardAccountsForTransfersDialog);
RegisterModalComponent(DIALOG_TYPE_MICRODEPOSIT_CONFIRMATION_FOR_TRANSFERS, MicrodepositConfirmationDialog);
RegisterModalComponent(DIALOG_TYPE_ACCOUNTS_TRANSFERS, AccountTransfersDialog);
RegisterModalComponent(DIALOG_TYPE_TRANSFER_ACTIVITY_DETAILS, TransferActivityDetails);
RegisterModalComponent(DIALOG_TYPE_INVESTMENT_TRANSACTIONS_EDIT, InvestmentTransactionEditDialog);
RegisterModalComponent(DIALOG_TYPE_SECURITY_EDIT, SecurityEditDialog);
RegisterModalComponent(DIALOG_TYPE_DELETE_REMINDER, DeleteReminderDialog);
RegisterModalComponent(DIALOG_TYPE_DELETE_TRANSACTION_RULE, DeleteTransactionRuleDialog);
RegisterModalComponent(DIALOG_TYPE_CANCEL_TRANSACTION_RULE, CancelTransactionRuleDialog);
RegisterModalComponent(DIALOG_TYPE_MATCH_TXN, MatchTxnDialog);
RegisterModalComponent(DIALOG_TYPE_PLANNED_SPENDING, AddPlannedSpending);
RegisterModalComponent(DIALOG_TYPE_PLANNED_SPENDING_EDIT, EditPlannedSpending);
RegisterModalComponent(EDIT_PLANNED_SPENDING_SERIES_DIALOG, EditPlannedSpendingSeries);
RegisterModalComponent(DIALOG_TYPE_PLANNED_SPENDING_DELETE, DeletePlannedSpending);
RegisterModalComponent(DIALOG_TYPE_EDIT_REMINDER, EditReminderDialog);
RegisterModalComponent(DIALOG_TYPE_VIEW_SERIES, ViewSeriesDialog);
RegisterModalComponent(DIALOG_TYPE_BILL_PRESENTMENT, BillPresentmentDialog);
RegisterModalComponent(DIALOG_TYPE_BILL_SCOUT, BillScoutDialog);
RegisterModalComponent(DIALOG_TYPE_REFUND_EDIT, RefundEditDialog);
RegisterModalComponent(DIALOG_TYPE_REFUND_MATCH, RefundMatchDialog);
RegisterModalComponent(DIALOG_TYPE_SCHEDULED_TRANSACTION_ADD, ScheduledTransactionAddDialog);
RegisterModalComponent(DIALOG_TYPE_ADD_RULE, AddRuleDialog);
RegisterModalComponent(DIALOG_TYPE_RENAME_RULE_EDIT, RenameRuleEditDialog);
RegisterModalComponent(DIALOG_TYPE_MEMORIZED_RULE_EDIT, MemorizedRuleEditDialog);
RegisterModalComponent(DIALOG_TYPE_EMPTY_DIALOG, EmptyDialog);
RegisterModalComponent(DIALOG_TYPE_REPORT_ERROR, ReportErrorDialog);
RegisterModalComponent(DIALOG_TYPE_ACCOUNT_EDIT, AccountEditDialog);
RegisterModalComponent(DIALOG_TYPE_IDENTITY_VERIFICATION_DIALOG, IdentityVerificationDialog);
ImportModalComponent(DIALOG_TYPE_TRANSACTION_DETAILS, () => import('components/Transactions/DetailsDialog'));
RegisterModalComponent(DIALOG_TYPE_PHONE_VERIFICATION_DIALOG, PhoneVerificationDialog);
RegisterModalComponent(DIALOG_TYPE_EMAIL_VERIFICATION_DIALOG, EmailVerificationDialog);
RegisterModalComponent(DIALOG_TYPE_CREDIT_SCORE_REGISTER, CreditScoreRegistrationDialog);
RegisterModalComponent(DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_SENT, CreditScoreVerificationSentDialog);
RegisterModalComponent(DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_EVENTS, CreditScoreVerificationEventsDialog);
RegisterModalComponent(DIALOG_TYPE_CREDIT_SCORE_LOADING, CreditScoreVerificationLoadingDialog);
RegisterModalComponent(DIALOG_TYPE_CREDIT_REPORT_UPDATE, CreditReportUpdateDialog);
RegisterModalComponent(DIALOG_TYPE_CANCEL_REGISTRATION, CreditReportCancelRegistrationDialog);
RegisterModalComponent(MANAGE_UPDATES_DIALOG, ManageUpdatesDialog);
ImportModalComponent(INVOICE_PAYMENT_ROOTUI_TYPE, () => import('components/InvoicePayment'));

function RootModal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const urlDialogFF = useSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'urlDialog'));
  const [searchParams] = useSearchParams();

  useEffect(() => {
    log.log('location changed to: ', location.pathname + location.search);
    if (isAuthenticated) {
      const url = new URL(window.location.href);
      const dialogType = url.searchParams?.get('showDialog');
      if (dialogType) {
        switch (dialogType) {
          case 'SOME_SPECIAL_DIALOG_ID_EXAMPLE': // if we need special handling
            break;
          default:
            dispatch(
              rootUiActions.createDialog(
                rootUiTypes.mkRootUiData({
                  id: dialogType,
                  type: dialogType,
                  allowNesting: true,
                }),
              ),
            );
        }

        url.searchParams.delete('showDialog');
        navigate(url.pathname + url.search, { replace: true });
      }
    }
  }, [location, dispatch, navigate, isAuthenticated]);

  const modalsSelector = useSelector(rootUiSelectors.getActiveModals);

  const searchProps = searchParams.get('dialogs');
  const urlDialogs = useMemo(() => {
    let returned = [];
    try {
      returned = JSON.parse(decodeURIComponent(searchProps));
    } catch (e) {
      log.error('Failed to parse search props for dialogs:', e);
    }
    return returned;
  }, [searchProps]);
  const modals = useMemo(() => {
    let modalList = modalsSelector;
    if (urlDialogs && urlDialogFF) {
      urlDialogs.forEach((props, index) => {
        const propsCopy = { ...props };
        delete propsCopy.dialogType;
        modalList = modalList.push(
          rootUiTypes.mkRootUiData({
            type: props.dialogType,
            props: ImmutableMap(propsCopy ?? {}),
            createdAt: props.createdAt,
            id: props.id || `url-dialog-${modalList.size + index}`,
          }),
        );
      });
    }
    return modalList.sort((a, b) => a.createdAt - b.createdAt);
  }, [modalsSelector, urlDialogs, urlDialogFF]);

  // Abstraction used to support dynamically importing components and resolving the promise before
  // attempt to display the component (would fail if react is given promise vs component).
  //
  const [modalComponents, setModalComponents] = useState([]);

  const loadModalComponents = useCallback(async (modalsParam) => {
    const loadedModalComponents = await Promise.all(
      modalsParam.map(async (modal) => {
        const modalProps = {};
        modal.props.forEach((value, key) => {
          modalProps[key] = value;
        });

        const ModalComponent = MODAL_COMPONENTS[modal.type];
        if (!ModalComponent) {
          return null;
        }

        if (ModalComponent instanceof Promise) {
          const resolvedImportedComponent = await ModalComponent;
          const ResolvedModalComponent = resolvedImportedComponent.default || resolvedImportedComponent;
          return <ResolvedModalComponent key={modal.id} dialogId={modal.id} {...modalProps} />;
        }
        return <ModalComponent key={modal.id} dialogId={modal.id} {...modalProps} />;
      }),
    );
    setModalComponents(loadedModalComponents);
  }, []);

  useEffect(() => {
    loadModalComponents(modals);
  }, [modals, loadModalComponents]);

  if (modalComponents.length === 0) {
    return null;
  }

  return modalComponents;
}

export default React.memo(RootModal);
